/**
 * assets/consent-banner-ux.js
 * Gedrag van snippets/consent-banner-ux.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  'use strict';

  var HERVRAAG_NA_DAGEN = 182;
  var C_KEUZE = 'vc_consent_ts';
  var C_HERVRAAGD = 'vc_consent_reask';

  function lees(naam) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + naam + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function schrijf(naam, waarde, dagen) {
    document.cookie = naam + '=' + encodeURIComponent(waarde) +
      '; path=/; max-age=' + Math.round(dagen * 86400) + '; SameSite=Lax; Secure';
  }

  /* 'yes' | 'no' | null (null = nog geen keuze gemaakt)*/
  function huidigeKeuze() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
    var c;
    try { c = cp.currentVisitorConsent(); } catch (e) { return null; }
    if (!c) return null;
    return (c.marketing === 'yes' || c.marketing === 'no') ? c.marketing : null;
  }

  function verwerk() {
    var keuze = huidigeKeuze();
    if (!keuze) return;

    var opgeslagen = lees(C_KEUZE);
    var delen = opgeslagen ? opgeslagen.split('|') : null;
    var tijdstempel = delen && Number(delen[1]);

    /* Eerste waarneming, of de bezoeker heeft zijn keuze gewijzigd: cyclus opnieuw starten.*/
    if (!delen || delen[0] !== keuze || !tijdstempel) {
      schrijf(C_KEUZE, keuze + '|' + Date.now(), 400);
      schrijf(C_HERVRAAGD, '', -1);
      return;
    }

    if (keuze !== 'no') return;
    if ((Date.now() - tijdstempel) / 86400000 < HERVRAAG_NA_DAGEN) return;
    if (lees(C_HERVRAAGD)) return;
    if (document.getElementById('shopify-pc__banner')) return;

    var pb = window.privacyBanner;
    if (!pb) return;
    var toon = pb.showBanner || pb.showPreferences;
    if (typeof toon !== 'function') return;

    schrijf(C_HERVRAAGD, String(Date.now()), 400);
    try { toon.call(pb); } catch (e) { /* stil: nooit de winkel breken op een banner */ }
  }

  /* Footer-knop "Cookievoorkeuren". De klikafhandeling zoekt de API pas op het*/
  /* moment van klikken op, zodat er geen race is met het laden van Shopify's script.*/
  function koppelVoorkeurenKnop() {
    var knop = document.getElementById('vc-cookie-prefs');
    var wrap = document.getElementById('vc-cookie-prefs-wrap');
    if (!knop || !wrap) return;

    knop.addEventListener('click', function () {
      var pb = window.privacyBanner;
      if (!pb || typeof pb.showPreferences !== 'function') return;
      try { pb.showPreferences(); } catch (e) { /* stil */ }
    });

    var pogingen = 0;
    (function toonZodraBeschikbaar() {
      var pb = window.privacyBanner;
      if (pb && typeof pb.showPreferences === 'function') {
        wrap.style.display = 'flex';
        return;
      }
      if (++pogingen > 20) return; /* ~10 s, daarna blijft de knop weg*/
      setTimeout(toonZodraBeschikbaar, 500);
    })();
  }

  function start() {
    koppelVoorkeurenKnop();
    document.addEventListener('visitorConsentCollected', verwerk);
    if (window.Shopify && window.Shopify.customerPrivacy) return verwerk();
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], verwerk);
    } catch (e) { /* stil */ }
    setTimeout(verwerk, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
